"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionFactoryV3 = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.collectionFactoryV3 = {
    [schemas_1.ChainId.MATIC_MUMBAI]: {
        version: '3',
        abi: abis_1.abis.CollectionFactoryV3,
        address: '0xDDb3781Fff645325C8896AA1F067bAa381607ecc',
        name: 'CollectionFactory',
        chainId: schemas_1.ChainId.MATIC_MUMBAI
    },
    [schemas_1.ChainId.MATIC_MAINNET]: {
        version: '3',
        abi: abis_1.abis.CollectionFactoryV3,
        address: '0x3195e88aE10704b359764CB38e429D24f1c2f781',
        name: 'CollectionFactory',
        chainId: schemas_1.ChainId.MATIC_MAINNET
    }
};
//# sourceMappingURL=collectionFactoryV3.js.map